import { NavLink } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-navy-950 text-navy-400 py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <p className="text-white font-semibold text-lg mb-2">Boligflow</p>
            <p className="text-sm leading-relaxed">
              Ejendomsadministration der virker — bygget til danske udlejere.
            </p>
          </div>
          <div>
            <p className="text-white text-sm font-semibold mb-3">Produkt</p>
            <ul className="space-y-2 text-sm">
              <li><NavLink to="/features" className="hover:text-white transition-colors">Funktioner</NavLink></li>
              <li><NavLink to="/pricing" className="hover:text-white transition-colors">Priser</NavLink></li>
            </ul>
          </div>
          <div>
            <p className="text-white text-sm font-semibold mb-3">Virksomhed</p>
            <ul className="space-y-2 text-sm">
              <li><NavLink to="/om-os" className="hover:text-white transition-colors">Om os</NavLink></li>
              <li><a href="mailto:hej@boligflow.dk" className="hover:text-white transition-colors">Kontakt</a></li>
            </ul>
          </div>
          <div>
            <p className="text-white text-sm font-semibold mb-3">Juridisk</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Privatlivspolitik</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Handelsbetingelser</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-navy-800 pt-6 text-sm text-center">
          &copy; {new Date().getFullYear()} Boligflow. Alle rettigheder forbeholdes.
        </div>
      </div>
    </footer>
  )
}
